export enum EAuthenticationSecretTypes {
  GOOGLE = 'google_token',
  X_EMPTY = 'x_empty', // -> returns redirect url
  X_TOKEN_AND_VERIFIER = 'x_token_and_verifier', // -> returns jwt
  LINKEDIN = 'linkedin_code',
  MAGIC_SIGN_IN_EMAIL = 'magic_sign_in_email',
  MAGIC_SIGN_IN_URI = 'magic_sign_in_uri',
}
